// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6c1IG","colMin":"styles_colMin__1dYfq"};